import script from "./PCSettingsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PCSettingsBlock.vue?vue&type=script&setup=true&lang=js"

import "./PCSettingsBlock.vue?vue&type=style&index=0&id=1554101a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1554101a"]])

export default __exports__